module.exports = __webpack_public_path__ + "71606cf67ff4024389ecf709657e9616.gif";